import { primitiveColors } from '../../theming';

export const chartColors = [
    primitiveColors.blue500,
    primitiveColors.mint600,
    '#A876FA',
    primitiveColors.nectarine500,
    primitiveColors.magenta500,
];